import {Box, Typography} from '@mui/material'

import './passwordRequirements.scss'

const PasswordRequirements = () => (
  <Box className='password-requirements'>
    <Typography className='requirements-title'>
      Password must be a minimum of 12 characters. Longer passwords are more secure.
    </Typography>
    <Typography className='requirements-subtitle'>
      Consider using a memorable phrase or use a password manager to generate one.
    </Typography>
  </Box>
)

export default PasswordRequirements
